import { del, get, post, put } from '../../../helpers/api'
import { api } from '../api'
import {
  SET_FORM_DATA,
  SET_SMART_LIBRARY_EFORM_LIST_DATA,
  SET_SMART_LIBRARY_FILE_TYPE_DATA,
  SET_SMART_LIBRARY_LIST_DATA,
  SET_SMART_LIBRARY_PRODUCT_DATA,
  SHOW_NOTIFICATION,
} from '../../../store/types'

export const getSmartLibraryProductAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.smartLibraryProduct, query).then(response => {
      const json = response.data.data
      commit(SET_SMART_LIBRARY_PRODUCT_DATA, {
        list: json.map(opt => ({ label: opt.sku, value: opt.id, sublabel: opt.name })),
      })

      resolve(response.data)
    })
  })
}
export const getSmartLibraryFileTypeAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.smartLibraryFileType, query).then(response => {
      const json = response.data.data
      commit(SET_SMART_LIBRARY_FILE_TYPE_DATA, {
        list: json.map(opt => ({ label: opt.name, value: opt.code })),
      })

      resolve(response.data)
    })
  })
}
export const getSmartLibraryListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.smartLibraryListing, query).then(response => {
      const json = response.data
      commit(SET_SMART_LIBRARY_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}
export const getSmartLibraryEFormListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.eFormListing, query).then(response => {
      const json = response.data
      commit(SET_SMART_LIBRARY_EFORM_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}
export const getSmartLibraryAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.smartLibrary + '/' + id).then(response => {
      const json = response.data
      // Simple hack to change switch state active or inactive
      // Since element ui v-model expecting true:false but API return 1:0
      // TODO Find optimal solutions
      if (json.new_joiner_essential_tools) {
        json.new_joiner_essential_tools = true
      } else {
        json.new_joiner_essential_tools = false
      }
      if (json.upload_file_data === json.upload_file_link) {
        json.upload_file_user = true
      } else {
        json.upload_file_user = false
      }
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}
export const createSmartLibraryAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.smartLibrary, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create Smart Library', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}
export const updateSmartLibraryAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.smartLibrary, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Smart Library', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}
export const deleteSmartLibraryAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.smartLibrary + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete Smart Library', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}
export const getEFormAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.eForm + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}
export const createEFormAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.eForm, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create e-Form', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}
export const updateEFormAction = ({ commit }, data) => {
  return new Promise(resolve => {
    put(api.eForm + '/' + data.id, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update e-Form', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}
export const deleteEFormAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.eForm + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete e-Form', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}
